import type { Cart } from 'domains/cart';
import type { PaymentType } from 'domains/cart_payment_method';
import type { LoadingStatus } from 'types/common_types';

export type CheckoutStatus = 'idle' | 'success' | 'error' | 'pending';
export type CheckoutSliceInitialState = {
  initialized: boolean;
  submitStatus: CheckoutStatus | 'submitting';
  submitError?: string;

  confirmationDetails: {
    status: LoadingStatus;
  };
};

export type ConfirmationDetails = Pick<Cart, 'customer_email' | 'reference'>;

export type CartSubmitData = {
  expected_total: number;
  expected_gift_certificate_usage_total?: number;
  braintree_payment_method_nonce?: string;
  braintree_device_data?: string;
  payment_type: PaymentType;
};
